import { CheckIcon, XMarkIcon } from '@heroicons/react/24/outline';
import { StarIcon } from '@heroicons/react/24/solid';

import UpgradePlanBanner from 'features/account/my-plan/UpgradePlanBanner';
import Card from 'honeydew/Card';
import { Divider } from 'honeydew/Divider';
import Tag from 'honeydew/Tag';

const gridClasses = 'grid grid-cols-3 gap-10';
const checkIconClasses = 'w-20 self-center justify-self-center text-kale';
const xIconClasses = 'w-20 self-center justify-self-center text-error';
const gridTextClasses = 'self-center justify-self-center';

function PlanOptions({ openUpgradeModal }) {
    return (
        <Card marginClasses="mt-20">
            <div className="grow gap-70 md:flex">
                <h2 className="text-body-lg mb-20 font-grotesk-bold md:min-w-[180px]">Plan Options</h2>
                <div className="relative">
                    <div className="text-body-sm relative z-10">
                        <div className={gridClasses}>
                            <p className="self-end font-grotesk-bold">Features</p>
                            <p className="self-end justify-self-center font-grotesk-bold">Flex Plan</p>
                            <div className="flex flex-col items-center text-center">
                                <Tag variant="dark">
                                    <StarIcon width="12px" className="relative inline lg:mr-[2px]" />
                                    <span className="hidden lg:inline-block">RECOMMENDED</span>
                                </Tag>
                                <p className="mt-5 justify-self-center font-grotesk-bold">Grocery Subscription</p>
                            </div>
                        </div>
                        <Divider my="my-10" />
                        <div className={gridClasses}>
                            <p>No membership fees</p>
                            <CheckIcon className={checkIconClasses} />
                            <CheckIcon className={checkIconClasses} />
                        </div>
                        <Divider my="my-10" />
                        <div className={gridClasses}>
                            <p>Automated weekly deliveries</p>
                            <XMarkIcon className={xIconClasses} />
                            <CheckIcon className={checkIconClasses} />
                        </div>
                        <Divider my="my-10" />
                        <div className={gridClasses}>
                            <p>No checkout needed</p>
                            <CheckIcon className={checkIconClasses} />
                            <CheckIcon className={checkIconClasses} />
                        </div>
                        <Divider my="my-10" />
                        <div className={gridClasses}>
                            <p>Earn loyalty points per dollar spent</p>
                            <p className={gridTextClasses}>1X</p>
                            <p className={gridTextClasses}>2X</p>
                        </div>
                        <Divider my="my-10" />
                        <div className={gridClasses}>
                            <p>Skip or pause any time</p>
                            <p className={gridTextClasses}>N/A</p>
                            <CheckIcon className={checkIconClasses} />
                        </div>
                        <Divider my="my-10" />
                        <div className={gridClasses}>
                            <p>First dibs on top-selling items</p>
                            <XMarkIcon className={xIconClasses} />
                            <CheckIcon className={checkIconClasses} />
                        </div>
                        <Divider my="my-10" />
                        <div className={gridClasses}>
                            <p>Convenience of your cart pre-filled for you each week</p>
                            <XMarkIcon className={xIconClasses} />
                            <CheckIcon className={checkIconClasses} />
                        </div>
                        <Divider my="my-10" />
                        <div className={gridClasses}>
                            <p>Ability to set food preferences</p>
                            <XMarkIcon className={xIconClasses} />
                            <CheckIcon className={checkIconClasses} />
                        </div>
                    </div>
                    <div className="bg-brand-secondary absolute -bottom-25 -right-20 -top-25 left-[66.67%] z-0 !bg-opacity-50 lg:-bottom-30 lg:-right-30 lg:-top-30 lg:left-[calc(66.67%_-_15px)]" />
                </div>
            </div>
            <UpgradePlanBanner openUpgradeModal={openUpgradeModal} flush />
        </Card>
    );
}

export default PlanOptions;
